import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql, Link } from 'gatsby';
import {
  TableofContents,
  DecorativeLink,
  PageHeader,
  ColoredHeading,
  Icon,
  Section,
  DangerousWrapper
} from '@budget-monorepo/shared-ui';
import kebabCase from 'lodash.kebabcase';

import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';

/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-closing-bracket-location */
const OutsideSectionPage = (props) => {
  const { data } = props;
  const { content, site, download } = data;
  const { outsideSections, parent } = content;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = parent;
  const createOutsideSectionSlug = (number, title) => kebabCase(`${number} ${title}`);

  const layoutProps = {
    activeIndex: 4,
    above: () => <PageHeader title={content.title} category={content.budgetSection} />,
    pageTitle: content.title,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime
  };
  // metadata for the page
  const metaTitle = `${content.title} Table of Content`;
  const metaDescription = `Table of Content of all outside sections: ${content.budgetSection}`;
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        <DangerousWrapper rawHtml={content.summary} htmlTag="p" />
        <Section>
          <Link to="/outside-section-all">
            <Icon name="arrowbent" svgHeight={20} svgWidth={35} className="ma__link--icon" />
            View All Outside Sections
          </Link>
          <DecorativeLink
            /* Create a reference link to the outside sections summary file */
            href={download.publicURL}
            text={`Download Outside ${content.budgetSection}`}
            showFileIcon
          />
        </Section>
        <Section>
          <TableofContents
            heading={<ColoredHeading text="Table of Contents" color="blue" />}
          >
            {outsideSections.map((section, index) => (
              <span className="ma__decorative-link">
                <Link
                  key={
                      // eslint-disable-next-line react/no-array-index-key
                      `toc-link-${index}`
                    }
                  to={`/outside-section/${createOutsideSectionSlug(section.budgetSection, section.title)}`}>
                  {`${section.budgetSection}. ${section.title}`}
                  <Icon name="arrow" />
                </Link>
              </span>
            ))}
          </TableofContents>
        </Section>
      </Layout>
    </Fragment>
  );
};

OutsideSectionPage.propTypes = {
  data: PropTypes.object
};

export default OutsideSectionPage;

export const query = graphql`
  query OutsideSectionPageQuery {
    site {
      ...SiteMetadata
    }
    # Fetch the url of the pdf file of the outside sections to create an in page download link.
    # If the file name changes, the query here (eq: "fy2023h2_tab3.pdf") will need to be updated.
    download: file(base: { eq: "fy2023h2_tab3.pdf" }) {
      publicURL
    }
    # Fetch the title and budget section of every outside section listed in the outside-section.json
    content: pagesJson(fields: { slug: { eq: "/outside-section/" } }) {
      title
      budgetSection
      outsideSections {
        title
        budgetSection
      }
      # Get the last modified timestamp for the file powering the page
      ...PagesJsonDataTimeStamp
    }
  }
`;
